import {Marketplace} from '../types';

const API_BASE = '/o/apx-rest/v1.0';

interface PageResult<T> {
    items?: T[];
}

const buildUrl = (url: string): string => {
    const separator = url.includes('?') ? '&' : '?';
    const scopeGroupId = Liferay.ThemeDisplay.getScopeGroupId();
    return `${API_BASE}${url}${separator}scopeGroupId=${scopeGroupId}`;
};

const throwResponseError = async (response: Response): Promise<never> => {
    let message = '';
    try {
        const errorJson = await response.json();
        message = errorJson.title ?? errorJson.detail ?? '';
    } catch {
        message = '';
    }
    throw new Error(message);
};

const request = async <TResponse>(url: string, options: RequestInit = {}): Promise<TResponse> => {
    const response = await Liferay.Util.fetch(buildUrl(url), {
        headers: {'Content-Type': 'application/json'},
        ...options,
    });

    if (!response.ok) {
        await throwResponseError(response);
    }

    return response.json() as Promise<TResponse>;
};

export const fetchMarketplaces = async (): Promise<Marketplace[]> => {
    const page = await request<PageResult<Marketplace>>('/marketplaces');
    return page.items ?? [];
};
